import "../../scss/footer.scss";

const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();

  const typeCheck = localStorage.getItem("type");

  if (typeCheck === "reservation") {
    return (
      <footer className="w-full bg-[#FAFAF8] border-t border-[#E5E2DB] py-2.5 shadow-[0_-1px_3px_rgba(0,0,0,0.04)]">
        <div className="max-w-6xl mx-auto px-4 text-center text-base font-semibold text-[#4e4c48] tracking-wider">
          {year}© SilverLine System Integrators Pvt. Ltd.
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      {year}© SilverLine System Integrators Pvt. Ltd.
    </footer>
  );
};

export default Footer;